import classnames from 'classnames';

export const getButtonsArray = (button, onClick, className) => {
  return [
    {
      onClick,
      classes: classnames(
        button.type,
        button.color,
        'large',
        className
      ),
      children: button.innerText,
      minWidth: 1600
    },
    {
      onClick,
      classes: classnames(
        button.type,
        button.color,
        'small',
        className
      ),
      children: button.innerText,
      maxWidth: 1599
    }
  ];
};



// WEBPACK FOOTER //
// ./src/uis/components/Banner/HeroBanner/utils.js